<template>
	<div v-if="icon">
		<v-icon v-if="!isUrl" :icon="mdiIcon" size="24" class="mr-2" />
		<img v-else :src="icon" alt="Enum icon" class="mr-2" style="max-width: 100px; max-height: 60px" />
	</div>
</template>

<script setup lang="ts">
import { computed } from "vue";

const props = defineProps({
	icon: {
		type: String,
		default: undefined,
	},
});

const isUrl = computed(() => {
	if (!props.icon) return false;
	return props.icon.startsWith("http://") || props.icon.startsWith("https://") || props.icon.startsWith("data:");
});

const mdiIcon = computed(() => {
	if (!props.icon || isUrl.value) return "";
	return props.icon.startsWith("mdi-") ? props.icon : `mdi-${props.icon}`;
});
</script>
